import * as React from 'react';
import { SVGProps } from 'react';

const SvgTooltipFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm-1.067-5.033a1.033 1.033 0 0 0 2.067 0v-4.934a1.033 1.033 0 0 0-2.067 0v4.934Zm1.078-10.56a1.3 1.3 0 0 0-1.3 1.297 1.3 1.3 0 0 0 2.6 0 1.3 1.3 0 0 0-1.3-1.297Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgTooltipFilled;
